import { makeStyles, Modal } from "@material-ui/core";
const useStyles = makeStyles(() => ({
    modalInside: {
        background: "white",
        width: "min(32rem, 90%)",
        minWidth: "max-content",
        margin: "40vh auto",
        borderRadius: "0.5rem",
        transform: "translateY(-50%)",
        overflow: "hidden",
    },
    header: {
        color: "white",
        background: "#0E7395",
        fontSize: "2rem",
        borderBottom: "1px solid #ebecf0",
        padding: "1rem",
        marginBlock: 0,
    },
    headerSecondary: {
        fontSize: "1.5rem",
        textAlign: "center",
    },
    list: {
        listStyle: "none",
        padding: "0 1rem",
        lineHeight: "2.5rem",
        "& .key": {
            backgroundColor: "#f7f7f7",
            border: "1px solid #ccc",
            borderRadius: "3px",
            boxShadow: "0 1px 0 rgb(0 0 0 / 20%), 0 0 0 2px #fff inset",
            color: "#333",
            margin: "0 0.1em",
            minWidth: "2em",
            padding: "0.1em 0.6em",
            textAlign: "center",
            textShadow: "0 1px 0 #fff",
        },
    },
}));
export const ShortcutsModal = (props) => {
    const classes = useStyles();
    return (<Modal style={{ zIndex: 99999 }} {...props}>
      <div className={classes.modalInside}>
        <h1 className={classes.header}>Keyboard Shortcuts</h1>
        <div style={{ padding: "0 1rem 1rem 1rem" }}>
          <h2 className={classes.headerSecondary}>Global Shortcuts</h2>
          <div style={{ display: "flex" }}>
            <ul className={classes.list}>
              <li>Navigate to Menu</li>
              <li>Navigate to Active Tab</li>
              <li>Navigate to Patient Header</li>
              <li>Navigate to Chart Tabs</li>
              <li>Open Notification Center</li>
              <li>Open Search</li>
            </ul>
            <ul className={classes.list} style={{ fontSize: 11 }}>
              <li>
                <span className="key">F2</span> or{" "}
                <span className="key">CTRL</span>+
                <span className="key">SHIFT</span>+
                <span className="key">H</span>
              </li>
              <li>
                <span className="key">F4</span> or{" "}
                <span className="key">CTRL</span>+
                <span className="key">SHIFT</span>+
                <span className="key">J</span>
              </li>
              <li>
                <span className="key">F7</span> or{" "}
                <span className="key">CTRL</span>+
                <span className="key">SHIFT</span>+
                <span className="key">K</span>
              </li>
              <li>
                <span className="key">F8</span> or{" "}
                <span className="key">CTRL</span>+
                <span className="key">SHIFT</span>+
                <span className="key">L</span>
              </li>
              <li>
                <span className="key">F9</span> or{" "}
                <span className="key">CTRL</span>+
                <span className="key">SHIFT</span>+
                <span className="key">G</span>
              </li>
              <li>
                <span className="key">CTRL</span>+<span className="key">M</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </Modal>);
};
